import { render, staticRenderFns } from "./templates-dynamic-textarea.vue?vue&type=template&id=652e7585&scoped=true&lang=pug"
import script from "./templates-dynamic-textarea.vue?vue&type=script&lang=js"
export * from "./templates-dynamic-textarea.vue?vue&type=script&lang=js"
import style0 from "./templates-dynamic-textarea.vue?vue&type=style&index=0&id=652e7585&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652e7585",
  null
  
)

export default component.exports